// extracted by mini-css-extract-plugin
module.exports = {"root":"RulesBlockEditor_root__4BUW8"};